import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _dataFromMap,
    _initSplitBarEvent,
} from "../comJs";
import GridPanelUtils from "./gridPanelUtils";
import GoTabUrl from "../goTabsUrl";

class ManageUserTab extends TabCell {


    constructor(vueObj, goTabs) {
        super();
        this.initFirstData = false;
        this.tabId = GoingUtils.getUUid(10);
        this.tabIdName = "manageUser";
        this.tabLabel = "管理员";
        this.dataFrom = _dataFromMap["user"];
        this.active = false;
        this.hasSaveGroup = false;
        this.initFirstData = false;
        if (AssertUtils.isNotEmpty(vueObj.value)) {
            this.defVals = vueObj.value;
        }
        this.goTabs = goTabs;
    }

    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.leftTopCellHeight = parseFloat(panelHeight + "") - 40;
        return `${GridPanelUtils.initLeftCellContent(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入编外单位名称", this.tabId, false, 160, 180)}`;
    }

    getRightCellContent(panelHeight) {
        return `${GridPanelUtils.initRightCellContent(panelHeight, this, 310)}`;
    }

    allCheckBoxClick() {
        throw new Error("Method not implemented.");
    }

    //选择账套触发
    changeAccountEvent(nodeId, cellObj) {
        if (AssertUtils.isNotEmpty(nodeId)) {
            this.initFirstData = true;
            cellObj.leftTopGrid.flushGridByUrl({
                url: GoTabUrl.queryOutUnitByAccountId(nodeId),
                params: GridPanelUtils.getLoadGridParams(cellObj, nodeId, "outUnit")
            });
        }
    }


    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, this.dataFrom, "name");
    }


    removeSelectedRecord() {
        throw new Error("Method not implemented.");
    }


    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.leftTopGrid != null && AssertUtils.isFunction(this.leftTopGrid.destructor)) {
            this.leftTopGrid.destructor();
            this.leftTopGrid = null;
        }
    }


    loadSysDefData() {

    }

    //初始化编外单位表格
    initOutUnitGrid() {
        let cellObj = this;
        cellObj.itemConfig["selLeftTopRecord"] = true;
        //待选数据
        cellObj.leftTopGrid = GridPanelUtils.initOutUnitGrid(cellObj, true, true);
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        this.initOutUnitGrid();
        //待选择数据的表格
        this.initAlreadyGrid();
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: () => {
                this.leftTopGrid.reloadData(GridPanelUtils.getLoadGridParams(this, null, "outUnit"));
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        this.initCtlEvent();
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }
}

function initManageUserTab(goTabs, vueObj) {
    let groupTab = new ManageUserTab(vueObj, goTabs);
    goTabs.addTabToFactory("manageUser", groupTab);
}

export default initManageUserTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/manageUserTab.js